import { render, staticRenderFns } from "./ReportActivityShareDialog.vue?vue&type=template&id=12312db8&"
import script from "./ReportActivityShareDialog.vue?vue&type=script&lang=ts&"
export * from "./ReportActivityShareDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports